// main landing screen
import { useState } from "react";
import { useHistory } from "react-router-dom";

import ContentFormatXW from "../content/webz/content-format-xw";

import WebbDividerMedium from "../content/webx/webb-divider-md";
import WebbDividerSmall from "../content/webx/webb-divider-sm";

import WebbIcon from "../content/webx/webb-icon";

import IntroHeaderModule from "../content/intro/intro-header";
import IntroActionsModule from "../content/intro/intro-actions";

import IntroIssuesModule from "../content/intro/intro-issues";
import IntroBenefitsModule from "../content/intro/intro-benefits";
import IntroMiddlewareModule from "../content/intro/intro-middleware";

import IntroChainsModule from "../content/intro/intro-chains";
import IntroChannelsModule from "../content/intro/intro-channels";

const media = 'https://img.freepik.com/free-vector/abstract-background-consisting-colorful-arcs-illustration_456031-149.jpg'

export default function Intro () {
  
  const history = useHistory();

  return(
    <ContentFormatXW 
      name = 'IWNS - Home'
      home = {`/`}
      link = {`/`}
      head = 'wide'
      form = 'full'
      avtr = { <> 
      
      
      </> }
      data = {
        <>
          <div className=""
            style={{
              backgroundImage:`url(${media})`, 
              backgroundRepeat:'no-repeat', 
              backgroundSize:'cover',
              height:''
            }}
          >
            <WebbDividerMedium />
            <WebbDividerMedium />
            <IntroHeaderModule/>
            <WebbDividerMedium />
            <div className="px-3">
              

              <WebbDividerMedium />
              <WebbDividerMedium />
              <WebbDividerMedium />

              <IntroActionsModule />
              
              <WebbDividerMedium />
              <WebbDividerMedium />
            </div>
            

          </div>
          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="px-3">
            <IntroIssuesModule />
          </div>
          
          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="px-3">
          <IntroBenefitsModule />
          </div>

          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="px-3">
          <IntroChainsModule />
          </div>

          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="px-3">
          <IntroChannelsModule />
          </div>

          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="px-3">
          <IntroMiddlewareModule />
          </div>


          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />

        </>
      } 
    />
  )
}